import React from "react";

function ProfileIcon() {
  return (
    <svg
      width={28}
      height={30}
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="navIcon noStroke"
    >
      <path
        d="M13.978 16.898C4.964 16.898 0 21.162 0 28.904 0 29.509.49 30 1.095 30H26.86c.605 0 1.095-.49 1.095-1.095 0-7.743-4.964-12.008-13.978-12.008zM2.23 27.81c.43-5.79 4.377-8.723 11.748-8.723 7.37 0 11.318 2.933 11.75 8.723H2.23zM13.978 0c-4.14 0-7.263 3.185-7.263 7.408 0 4.347 3.258 7.884 7.263 7.884s7.263-3.537 7.263-7.883C21.24 3.185 18.119 0 13.978 0zm0 13.102c-2.797 0-5.073-2.554-5.073-5.693 0-3.024 2.134-5.22 5.073-5.22 2.893 0 5.073 2.244 5.073 5.22 0 3.14-2.275 5.693-5.073 5.693z"
        fill="#412A7C"
      />
    </svg>
  );
}

export default ProfileIcon;
